import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import StopIcon from '@material-ui/icons/Stop';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import Rating from '@material-ui/lab/Rating';
// removed unused style helpers
import { useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from "src/utils/axios";




function DataAi({ AiOpen, setAiOpen, FisNo, Telefon }) {

 
  const [AiData, setAiData] = useState([]);

  const [callId, setcallId] = useState(0);
  const [AiGoster, setAiGoster] = useState(false);
  const [speaking, setSpeaking] = useState(false);


  useEffect(() => {
    if (!AiOpen) {
      return;
    }

    axios.get(`GetArtemisDataAi/${FisNo}/${Telefon}`)
      .then(response => {
        setAiData(response.data);

        setcallId(response.data[0]?.callId);
    
        setAiGoster(AiOpen);
      }).catch(() => {

      });
  }, [AiOpen, FisNo, Telefon]);

  const handleAiKapat = () => {
    setAiOpen(false);
    setAiGoster(false);
  }
  // StyledRating removed (unused)

  const customIcons = {
    1: {
      icon: <SentimentVeryDissatisfiedIcon />,
      label: 'Very Dissatisfied',
    },
    2: {
      icon: <SentimentVerySatisfiedIcon />,
      label: 'Dissatisfied',
    },
  };
  const customIconsSales = {
    1: {
      icon: <SentimentVeryDissatisfiedIcon />,
      label: 'Very Dissatisfied',
    },
    2: {
      icon: <SentimentVerySatisfiedIcon />,
      label: 'Dissatisfied',
    },
  };
  function IconContainerSales(props) {
    const { value, ...other } = props;
    if (value === 1) {
      return <span {...other} style={{
        display: 'block', // Öğeyi blok seviyesine çıkararak width ve text-align'ı etkili kılar
        width: 100,
        textAlign: 'left'
      }}>{customIconsSales[value].icon}</span>;
    } else {
      return <span {...other} style={{
        display: 'block', // Öğeyi blok seviyesine çıkararak width ve text-align'ı etkili kılar
        width: 100,
        textAlign: 'right'
      }}>{customIconsSales[value].icon}</span>;
    }

  }




  function IconContainer(props) {
    const { value, ...other } = props;
    if (value === 1) {
      return <span {...other} style={{
        display: 'block', // Öğeyi blok seviyesine çıkararak width ve text-align'ı etkili kılar
        width: 100,
        textAlign: 'left'
      }}>{customIconsSales[value].icon}</span>;
    } else {
      return <span {...other} style={{
        display: 'block', // Öğeyi blok seviyesine çıkararak width ve text-align'ı etkili kılar
        width: 100,
        textAlign: 'right'
      }}>{customIconsSales[value].icon}</span>;
    }

  }
  const handleSpeak = () => {
    setSpeaking(true);
  };

  const handleStop = () => {
    setSpeaking(false);
  };


  const setGorusmeTeknisyenDegerlendir = (Param) => {
    setGorusmeTeknisyenDegerlendirEvet(Param,1);
  }
  const setSatisTeknisyenDegerlendir = (Param) => {
    setGorusmeTeknisyenDegerlendirEvet(Param, 2);
  }
  const setGorusmeTeknisyenDegerlendirEvet =(Param, Type)=>{
    axios.get(`SetArtemisDataAiDegerlendir/${callId}/${Param}/${Type}`)
      .then(() => {      

      }).catch(() => {});
  }


  return (
    <Dialog
      open={AiGoster}
      onClose={() => handleAiKapat()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
   
    >
      <DialogTitle id="alert-dialog-title">
        Çağrı Merkezi Görüşme
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={1} >
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <IconButton onClick={handleSpeak} disabled={speaking} color="primary" variant="contained">
              <VolumeUpIcon />
              Oku
            </IconButton>
            <IconButton onClick={handleStop} disabled={!speaking} color="primary" variant="contained">
              <StopIcon />
              Durdur
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Görüşme Özeti
            </Typography>
            <Typography variant="body2" gutterBottom>
              {AiData[0]?.GorusmeOzeti}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box component="fieldset" mb={3} borderColor="transparent">
              <Typography variant="h6" gutterBottom>
                Görüşme Özeti Doğruluğunu Değerlendir
              </Typography>
              <Rating
                name="customized-icons1"
                defaultValue={0}
                max={2}
                onChange={(event, newValue) => {
                  setGorusmeTeknisyenDegerlendir(newValue);
                }}
                getLabelText={(value) => customIcons[value].label}
                IconContainerComponent={IconContainer}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <IconButton color="primary" variant="contained">
              <LoyaltyIcon />
              Fırsatları Göster
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Satış Fırsatı
            </Typography>
            <Typography variant="body2" gutterBottom>
              {AiData[0]?.SatisFirsati}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box component="fieldset" mb={2} borderColor="transparent">
              <Typography variant="h6" gutterBottom>
                Satış Fırsatının Doğruluğunu Değerlendir
              </Typography>
              <Rating
                name="customized-icons2"
                size="large"
                defaultValue={0}
                max={2}
                onChange={(event, newValue) => {
                  setSatisTeknisyenDegerlendir(newValue);
                }}
                getLabelText={(value) => customIconsSales[value].label}
                IconContainerComponent={IconContainerSales}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => handleAiKapat()}
          endIcon={<CloseIcon>Close</CloseIcon>}
        >
          Kapat
        </Button>

      </DialogActions>
   
    </Dialog>
  );
}

export default DataAi;
